<template>
  <div v-if="hasPermission(Admin.companyDeployRead)">
    <TicketDesign
        v-if="showModal"
        :layout="layoutId"
        @getTicketLayoutByCompany="getTicketLayoutByCompany"
        @close="close"
    />
    <Table v-else-if="$store.getters.getTicketLayoutListCompany">
      <template v-slot:header>
        <tr>
          <td class="font_detail">SL</td>
          <td class="font_detail">NAME</td>
          <td class="font_detail">STATUS</td>
          <td class="font_detail">ACTION</td>
        </tr>
      </template>
      <template v-slot:body>
        <tr
            v-for="(layout, index) in $store.getters.getTicketLayoutListCompany"
            :key="layout._id"
        >
          <td class="font_detail">
            {{ index + 1 }}
          </td>
          <td class="font_detail">{{ layout.name }}</td>
          <td>
            <span v-if="layout.status" class="badge bg-success">{{
                dropdownVariables.status[1]
              }}</span>
            <span v-else class="badge bg-danger">{{
                dropdownVariables.status[0]
              }}</span>
          </td>
          <td>
            <button
                v-if="hasPermission(Admin.companyDeployWrite)"
                class="edit_table_data edit_table_button font_detail"
                @click="updateModal(layout._id)"
            >
              <i class="fas fa-pencil-alt"></i><span class="mx-1">Edit</span>
            </button>

          </td>
        </tr>
      </template>

    </Table>

  </div>
</template>

<script>
import { inject, onMounted, ref } from "vue";
import store from "@/store";
import dropdownVariables from "@/modules/dropdownVariables";
import web from "@/urls/web";
import permission from "@/modules/permission";
import roles from "@/modules/roles";
import TicketDesign from "@/views/Admin/CompanyDeploy/Children/TicketDesign/TicketDesign";
const { hasPermission } = permission();
const { Admin } = roles();
import { useRoute } from "vue-router";


export default {
  name: "DesignList",
  props: {
  },
  components: { TicketDesign },
  setup() {

    const layoutId = ref("");
    const showModal = ref(false);
    const manageUrl = web.Admin.COMPANY_DEPLOY_URL.children.MANAGE_URL.name;
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const route = useRoute();




    const getTicketLayoutByCompany = () => {
      showLoader();
      store
          .dispatch("getTicketLayoutByCompany", {companyId: route.query.id})
          .then(() => {
            hideLoader();
          })
          .catch((error) => {
            hideLoader();
            if (error.status === 401) {
              getTicketLayoutByCompany();
            }
          });
    };

    const updateModal = (value) => {
      layoutId.value = value;
      showModal.value = true;
    };
    const close = () => {
      showModal.value = false
    }

    onMounted(getTicketLayoutByCompany);

    return {
      manageUrl,
      showModal,
      layoutId,
      dropdownVariables,
      Admin,
      hasPermission,
      getTicketLayoutByCompany,
      updateModal,
      close,
    };
  },
};
</script>

<style scoped>
.setting_table_button {
  margin: 1px 2px;
  border: 2px solid #4285f4;
  border-radius: 4px;
  background-color: #4285f4;
  padding: 2px 6px;
  color: #fff;
  position: relative;
  font-size: 14px;
  font-family: Helvetica Neue;
}

.setting_table_button:hover,
.setting_table_button:focus {
  border: 2px solid #4285f4;
  background-color: #fff;
  color: #4285f4;
  transition: 0.4s;
  outline: 0;
}
</style>
